export default __webpack_public_path__ + "media/zurb/img/services/tools/foundation-screenshot1-4b346989ff3b4775b202a9d578c84be2.png";